import { render, staticRenderFns } from "./supplierStatisticsReport.vue?vue&type=template&id=636d02ec&"
import script from "./supplierStatisticsReport.vue?vue&type=script&lang=js&"
export * from "./supplierStatisticsReport.vue?vue&type=script&lang=js&"
import style0 from "./supplierStatisticsReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports